import { View } from "services/databases/getViews";
import { Database } from "services/databases/useDatabasesNames";
import { Table } from "services/databases/useTableNames";
import { WorkspaceEngine } from "services/engines/engine.types";
import { PrivilegeObjectType, Role } from "services/rbac/types";
import { User } from "services/users/user.types";

import { OwnershipRecord } from "components/AccountOwnership/types";

export const DEFAULT_ACCOUNT_OWNERSHIP_FILTERS = {
  nameContains: "",
  objectTypes: [],
  owners: [],
};

export const MAP_TO_OWNERSHIP_RECORD = {
  [PrivilegeObjectType.database]: (database: Database): OwnershipRecord => ({
    key: [database.catalogName, PrivilegeObjectType.database].join(","),
    type: PrivilegeObjectType.database,
    name: database.catalogName,
    owner: database.catalogOwner,
    created: database.created,
    lastModified: database.lastAltered,
  }),
  [PrivilegeObjectType.table]: (
    table: Table,
    databaseName: string
  ): OwnershipRecord => ({
    key: [table.tableName, databaseName, PrivilegeObjectType.table].join(","),
    type: PrivilegeObjectType.table,
    parentName: databaseName,
    name: table.tableName,
    owner: table.tableOwner,
    created: table.created,
    lastModified: table.lastAltered,
  }),
  [PrivilegeObjectType.engine]: (engine: WorkspaceEngine): OwnershipRecord => {
    return {
      key: [engine.engineName, PrivilegeObjectType.engine].join(","),
      type: PrivilegeObjectType.engine,
      name: engine.engineName,
      owner: engine.engineOwner || "",
      created: engine.created,
      lastModified: engine.lastAltered,
    };
  },
  [PrivilegeObjectType.view]: (
    view: View,
    databaseName: string
  ): OwnershipRecord => {
    return {
      key: [view.tableName, databaseName, PrivilegeObjectType.view].join(","),
      type: PrivilegeObjectType.view,
      parentName: databaseName,
      name: view.tableName,
      owner: view.viewOwner,
      created: view.created,
      lastModified: view.lastAltered,
    };
  },
  [PrivilegeObjectType.role]: (role: Role): OwnershipRecord => {
    return {
      key: [role.roleName, PrivilegeObjectType.role].join(","),
      type: PrivilegeObjectType.role,
      name: role.roleName,
      owner: role.roleOwner,
      created: role.created,
      lastModified: "",
    };
  },
  [PrivilegeObjectType.user]: (user: User): OwnershipRecord | null => {
    if (!user.userOwner) return null;
    return {
      key: [user.userName, PrivilegeObjectType.user].join(","),
      type: PrivilegeObjectType.user,
      name: user.userName,
      owner: user.userOwner,
      created: user.created,
      lastModified: user.lastAltered,
    };
  },
};

export const NO_OWNER_LABEL = "NULL";
export const DELETE_OWNERSHIP_OBJECT_RESERVED_VALUE = "_DELETE_";
